var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artist-info-wrap"},[_c('div',{staticClass:"artist-info-wrap__layout"},[_c('ArtistInfo',{attrs:{"artist":_vm.artistInfo}}),_c('NewsFeed',{attrs:{"artworkId":_vm.artworkId,"artistId":_vm.artistInfo.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }